import React, { ReactNode } from 'react';
import { useInitializeResponiveState } from '../store/responsiveStore';

interface ResponsiveProviderProps {
  children: ReactNode;
}

/**
 * Provider component that initializes the responsive state
 * Place this at the top level of your app to ensure responsive state is available globally
 */
export const ResponsiveProvider: React.FC<ResponsiveProviderProps> = ({ children }) => {
  // Initialize responsive state
  useInitializeResponiveState();
  
  return <>{children}</>;
}; 